import React, {useState, useEffect} from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import {useSMCSnackbar} from '../../utils/hooks';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import {SMCSelect, SMCOption} from '../../components/Simple/SMCSelect';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCPasswordInput from '../../components/Simple/SMCPasswordInput';

const READ_WRITE_VALUE = 'Read-Write';
const READ_ONLY_VALUE = 'Read only';

function GatewayAdminEditorModal({
    isOpen = false,
    width = 610,
    height = 480,
    isFirstAdministrator,
    onCancel,
    onSuccess,
    defaultObject
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar, closeSnackbar } = useSMCSnackbar();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [role, setRole] = useState(READ_WRITE_VALUE);

    const onFinish = () => {
        // Validate
        const adminUsernameRegex = new RegExp("[a-zA-Z0-9_\\-\\.]+");
        if (!username || username.length > 20 || !adminUsernameRegex.exec(username)) {
            enqueueErrorSnackbar(t('SMP.NAME')+': '+t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATORS.GW_ADMINS_TOPIC.NEW.USER_NAME_ERR'), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        if (!password || password.length < 2) {
            enqueueErrorSnackbar(t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATORS.GW_ADMINS_TOPIC.NEW.PASSWORD_ERR'), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        if (password !== confirmPassword) {
            enqueueErrorSnackbar(t('com.sofaware.db.PASSWORDS_DO_NOT_MATCH'), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        closeSnackbar();
        onSuccess({ username, password, role });
    }
    const _onCancel = () => {
        closeSnackbar();
        onCancel();
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            // Set default values
            setUsername('');
            setPassword('');
            setConfirmPassword('');
            setRole(READ_WRITE_VALUE);

            if (defaultObject) {
                defaultObject.username && setUsername(defaultObject.username);
                defaultObject.password && setPassword(defaultObject.password);
                defaultObject.password && setConfirmPassword(defaultObject.password);
                defaultObject.role && setRole(defaultObject.role);
            }
        }
    }, [isOpen, defaultObject]);

    return (
        <SMCModal
            isOpen={isOpen}
            width={width}
            height={height}
            title={t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATOR.GW_ADMIN_WIZ.GW_ADMIN')}
            onRequestClose={_onCancel}
        >
            <SMCModalBody>
                <SMCLabel bold>{t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATOR.GW_ADMIN_WIZ.LINE1')}</SMCLabel>
                <SMCTextInput
                    noAutoComplete
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    label={t('SMP.NAME')}
                />
                <SMCPasswordInput
                    noAutoComplete
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    label={t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATOR.GW_ADMIN_WIZ.PASSWORD')}
                    allowPasswordPeek={true}
                />
                <SMCPasswordInput
                    noAutoComplete
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    label={t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATOR.GW_ADMIN_WIZ.CONFIRM_PASSWORD')}
                    allowPasswordPeek={true}
                />
                <SMCSelect
                    value={role}
                    onChange={e => setRole(e.target.value)}
                    disabled={!!isFirstAdministrator}
                    label={t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATOR.GW_ADMIN_WIZ.PERMISSION')}
                    tooltip={t('SMP.PLANS.DEVICE_SETTINGS.ADMINISTRATOR.GW_ADMIN_WIZ.PERMISSION.TOOLTIP')}
                >
                    <SMCOption value={READ_WRITE_VALUE}>{t('Read Write')}</SMCOption>
                    <SMCOption value={READ_ONLY_VALUE}>{t('Read Only')}</SMCOption>
                </SMCSelect>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={_onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>

    );
}

export default GatewayAdminEditorModal;